<template>
  <div class="web-body">
    <div class="web-header">
      <div class="web-1170">
        <img class="web-logo" :src="this.$api_url+'/static/images/logo.png'">
      </div>
    </div>
    <div class="web-nav">
      <div class="web-1170">
        <Header></Header>
      </div>
    </div>
    <div class="web-content">
      <div class="web-1170">
        <div class="web-carousel">
          <el-carousel height="150px">
            <el-carousel-item v-for="(item,index) in carousel" :key="index">
              <a :href="item.link !=='0'?item.link:'#'" target="_self">
                <img :src="url + '/static/upload' + item.images">
              </a>
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="web-content-text">
          <h3>{{ szjjTitle }}<a href="/szjj">更多></a></h3>
          <ul>
            <li v-for="(item,index) in szjjContent" :key="index">
              <a :href="'/content/'+item.id">
                                <span class="date">
                                    <p>{{ item.add_date.split('-')[1] }}-{{ item.add_date.split('-')[2] }}</p>
                                    <p class="day">{{ item.add_date.split('-')[0] }}</p>
                                </span>

                <span class="title">{{ item.title }}</span>
              </a>
            </li>
          </ul>
        </div>

        <!--                    <h4>我校召开师德专题教育动员部署会</h4>-->
        <!--                    <p>会议传达和学习了《陈宝生同志在2021年教师思想政治和师德师风建设经验交流暨师德专题教育启动部署会上的讲话》精神，宣读了《山西省临汾工商行政管理学校师德专题教育工作方案》，对我校师德专题教育工作进行了部署./</p>-->
        <!--                </div>-->
        <div class="web-content-text">
          <h3>{{ xxywTitle }}<a href="/xxyw">更多 ></a></h3>
          <ul>
            <li v-for="(item,index) in xyywContent" :key="index">
              <a :href="'/content/'+item.id">
                                <span class="date">
                                    <p>{{ item.add_date.split('-')[1] }}-{{ item.add_date.split('-')[2] }}</p>
                                    <p class="day">{{ item.add_date.split('-')[0] }}</p>
                                </span>

                <span class="title">{{ item.title }}</span>
              </a>
            </li>
          </ul>
        </div>
        <div class="web-content-text" style="margin-right: 0px">
          <h3>{{ tzggTitle }}<a href="/tzgg">更多 ></a></h3>
          <ul>
            <li v-for="(item,index) in content" :key="index">
              <a :href="'/content/'+item.id">
                                <span class="date">
                                    <p>{{ item.add_date.split('-')[1] }}-{{ item.add_date.split('-')[2] }}</p>
                                    <p class="day">{{ item.add_date.split('-')[0] }}</p>
                                </span>
                <span class="title">{{ item.title }}</span>
              </a>
            </li>
          </ul>
        </div>
        <div class="middle-img">
          <a href="http://ztjy.people.cn/">
            <img src="../../../public/images/sxglzyxy.jpg"/>
          </a>
        </div>
        <div class="web-content-text">
          <h3>{{ kfdxTitle }}<a href="/zsjj">更多 ></a></h3>
          <ul>
            <li v-for="(item,index) in kfdxContent" :key="index">
              <a :href="'/content/'+item.id">
                                <span class="date">
                                    <p>{{ item.add_date.split('-')[1] }}-{{ item.add_date.split('-')[2] }}</p>
                                    <p class="day">{{ item.add_date.split('-')[0] }}</p>
                                </span>

                <span class="title">{{ item.title }}</span>
              </a>
            </li>
          </ul>
        </div>
        <div class="web-content-text">
          <h3>{{ shpxTitle }}<a href="/pxjj">更多 ></a></h3>
          <ul>
            <li v-for="(item,index) in shpxContent" :key="index">
              <a :href="'/content/'+item.id">
                                <span class="date">
                                    <p>{{ item.add_date.split('-')[1] }}-{{ item.add_date.split('-')[2] }}</p>
                                    <p class="day">{{ item.add_date.split('-')[0] }}</p>
                                </span>

                <!--                <el-tooltip class="item" effect="dark" :content="item.title" placement="top">-->
                <span class="title">{{ item.title }}</span>
                <!--                </el-tooltip>-->
              </a>
            </li>
          </ul>
        </div>
        <div class="web-content-link">
          <h3>专题网站<a href="#">更多 ></a></h3>
          <ul>
            <li v-for="(item,index) in link" :key="index">
              <a :href="item.link">{{ item.title }}</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="web-footer">
      <div class="web-1170">
        <Footer></Footer>
      </div>
    </div>
    <div>
<!--      <Qrfloat pos="left" isFd="true" v-if="indexImg.length>0">-->
<!--        <a :href="indexImg[0].url">-->
<!--          <img :src="url + '/static/upload' + indexImg[0].link"/>-->
<!--        </a>-->
<!--      </Qrfloat>-->
      <MoveWindow>
        <a :href="indexImg[0].url">
          <img :src="url + '/static/upload' + indexImg[0].link"/>
        </a>
      </MoveWindow>
    </div>
    <div>
      <Qrfloat pos="right">
        <span>学习强国</span>
        <img src="../../../public/images/xxqg.jpg"/>
        <span>关注学校公众号</span>
        <img src="../../../public/images/xxgzh.jpg"/>
      </Qrfloat>
    </div>

  </div>
</template>

<script>

import("../../../public/css/web.css")
import Footer from "./footer"
import Header from "./header"
import Qrfloat from "./qrfloat"
import MoveWindow from './moveWindow.vue'

// import {Tooltip} from 'element-ui';

export default {
  name: "page_index",
  components: {Footer, Header, Qrfloat,MoveWindow},
  data() {
    return {
      carousel: [],
      tzggTitle: '',
      content: [],
      xxywTitle: '',
      xyywContent: [],
      szjjTitle: '',
      szjjContent: [],
      kfdxTitle: '',
      kfdxContent: [],
      shpxTitle:'',
      shpxContent: [],
      link: [],
      url: this.$api_url,
      indexImg: []
    };
  },
  // 监听属性
  computed: {},
  // 监控data数据变化
  watch: {},
  // 方法集合
  methods: {
    getCarousel() {
      this.$api.get('/api/web/carousel-array/', {"url": this.$route.path}).then((response) => {
        this.carousel = response.carousel;
        console.log('img', this.carousel);
      })
    },
    getContent() {
      this.$api.get('/api/web/index-content-array/', {"url": this.$route.path}).then((response) => {
        this.content = response.content
        this.tzggTitle = response.itemName;
        console.log(response)
      })
    },
    getXxywContent() {
      this.$api.get('/api/web/index-xxyw-array/', {"url": this.$route.path}).then((response) => {
        this.xyywContent = response.xxyw,
            this.xxywTitle = response.itemName;
        console.log("this.xyywContent", this.xyywContent);
      })
    },
    getszjjContent() {
      this.$api.get('/api/web/index-szjj-array/', {"url": this.$route.path}).then((response) => {
        this.szjjContent = response.szjj
        this.szjjTitle = response.itemName;
        console.log("this.szjjContent", this.szjjContent);
      })
    },
    getKfdxContent() {
      this.$api.get('/api/web/index-kfdx-array/').then((response) => {
        this.kfdxContent = response.kfdx;
        this.kfdxTitle = response.itemName;
        console.log("this.kfdxContent", this.kfdxContent);
      })
    },
    getShpxContent() {
      this.$api.get('/api/web/index-shpx-array/').then((response) => {
        this.shpxContent = response.shpx;
        this.shpxTitle = response.itemName;
        console.log("this.shpxContent", this.shpxContent);
      })
    },
    getLink() {
      this.$api.get('/api/web/index-link-array/').then((response) => {
        this.link = response.link
      })
    },

  },
  // 生命周期 - 创建之前
  beforeCreate() {
  },
  // 生命周期 - 创建完成
  created() {
    this.$api.get('/api/web/index-img/').then((response) => {
      console.log('test-img', response);
      this.indexImg = response.img;
    })
  },
  // 生命周期 - 挂载之前
  beforeMount() {
  },
  // 生命周期 - 挂载完成
  mounted() {
    this.getCarousel()
    this.getContent()
    this.getXxywContent();
    this.getszjjContent();
    this.getKfdxContent();
    this.getShpxContent();
    this.getLink();
  },
  // 生命周期 - 更新之前
  beforeUpdate() {
  },
  // 生命周期 - 更新之后
  updated() {
  },
}
</script>
